// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ─── Breadcrumb ─────────────────────────────────────────────────────────────
   Figma spec:
   - Default  color: #8A8B8F
   - Hover    color: rgba(0,0,0,0.8)
   - Active   color: #2388FF
   - Focus    color: #2388FF  (visible ring)
   - Separator "/": always #8A8B8F
   ─────────────────────────────────────────────────────────────────────────── */

.scl--cms-content-edit-product-breadcrumb {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 6px;
  margin-bottom: 14px;
}

/* ── Item button ─────────────────────────────────────────────────────────── */
.scl--cms-content-edit-product-breadcrumb-item {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 0 0 1px;
  gap: 6px;

  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #8A8B8F;

  background: none;
  border: none;
  outline: none;       /* remove default browser outline — we draw our own */
  cursor: pointer;
  transition: color 0.15s ease;
}

/* ── Force ALL svg children to inherit currentColor ─────────────────────── */
/* Covers path, rect, circle, polyline, line regardless of stroke or fill   */
.scl--cms-content-edit-product-breadcrumb-item svg {
  width: 16px;
  height: 16px;
  flex-shrink: 0;
  color: inherit;          /* cascade currentColor into the SVG element      */
}

.scl--cms-content-edit-product-breadcrumb-item svg *,
.scl--cms-content-edit-product-breadcrumb-item svg path,
.scl--cms-content-edit-product-breadcrumb-item svg rect,
.scl--cms-content-edit-product-breadcrumb-item svg circle,
.scl--cms-content-edit-product-breadcrumb-item svg line,
.scl--cms-content-edit-product-breadcrumb-item svg polyline {
  stroke: currentColor !important;
  fill: none !important;      /* icons are outline style — no fill           */
  transition: stroke 0.15s ease;
}

/* Exception: if an icon child explicitly needs fill (e.g. solid icon),
   add class scl--fill to that SVG and override here */
.scl--cms-content-edit-product-breadcrumb-item svg.scl--fill *,
.scl--cms-content-edit-product-breadcrumb-item svg.scl--fill path {
  fill: currentColor !important;
  stroke: none !important;
}

/* ── Hover ───────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-product-breadcrumb-item:hover:not(:disabled) {
  color: rgba(0, 0, 0, 0.8);
}

/* ── Focus-visible — keyboard / programmatic focus ──────────────────────── */
.scl--cms-content-edit-product-breadcrumb-item:focus-visible:not(:disabled) {
  color: #2388FF;
  /* Subtle underline instead of a box — keeps layout stable */
  text-decoration: underline;
  text-underline-offset: 3px;
}

/* ── Active / current page ───────────────────────────────────────────────── */
.scl--cms-content-edit-product-breadcrumb-item--active:not(:disabled)  {
  color: #2388FF;
  cursor: default;
}

/* ── Disabled ────────────────────────────────────────────────────────────── */
.scl--cms-content-edit-product-breadcrumb-item:disabled {
  cursor: default;
  color: #8A8B8F;
}

/* ── Separator "/" ───────────────────────────────────────────────────────── */
.scl--cms-content-edit-product-breadcrumb-sep {
  font-family: 'Inter', sans-serif;
  font-weight: 400;
  font-size: 12px;
  line-height: 18px;
  color: #8A8B8F;
  pointer-events: none;
  user-select: none;
}`, "",{"version":3,"sources":["webpack://./src/component-controller-mod/component-serv/navigation-fs-cp/breadcrumb-nav-op/edit-content-breadcrumb/css/editContentBreadcrumb.css"],"names":[],"mappings":"AAAA;;;;;;;gFAOgF;;AAEhF;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA,+EAA+E;AAC/E;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,mBAAmB;EACnB,gBAAgB;EAChB,QAAQ;;EAER,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;;EAEd,gBAAgB;EAChB,YAAY;EACZ,aAAa,QAAQ,qDAAqD;EAC1E,eAAe;EACf,4BAA4B;AAC9B;;AAEA,8EAA8E;AAC9E,6EAA6E;AAC7E;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc,WAAW,mDAAmD;AAC9E;;AAEA;;;;;;EAME,+BAA+B;EAC/B,qBAAqB,OAAO,gDAAgD;EAC5E,6BAA6B;AAC/B;;AAEA;sDACsD;AACtD;;EAEE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA,+EAA+E;AAC/E;EACE,yBAAyB;AAC3B;;AAEA,8EAA8E;AAC9E;EACE,cAAc;EACd,4DAA4D;EAC5D,0BAA0B;EAC1B,0BAA0B;AAC5B;;AAEA,+EAA+E;AAC/E;EACE,cAAc;EACd,eAAe;AACjB;;AAEA,+EAA+E;AAC/E;EACE,eAAe;EACf,cAAc;AAChB;;AAEA,+EAA+E;AAC/E;EACE,gCAAgC;EAChC,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,oBAAoB;EACpB,iBAAiB;AACnB","sourcesContent":["/* ─── Breadcrumb ─────────────────────────────────────────────────────────────\n   Figma spec:\n   - Default  color: #8A8B8F\n   - Hover    color: rgba(0,0,0,0.8)\n   - Active   color: #2388FF\n   - Focus    color: #2388FF  (visible ring)\n   - Separator \"/\": always #8A8B8F\n   ─────────────────────────────────────────────────────────────────────────── */\n\n.scl--cms-content-edit-product-breadcrumb {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 6px;\n  margin-bottom: 14px;\n}\n\n/* ── Item button ─────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-product-breadcrumb-item {\n  display: flex;\n  flex-direction: row;\n  justify-content: center;\n  align-items: center;\n  padding: 0 0 1px;\n  gap: 6px;\n\n  font-family: 'Inter', sans-serif;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  color: #8A8B8F;\n\n  background: none;\n  border: none;\n  outline: none;       /* remove default browser outline — we draw our own */\n  cursor: pointer;\n  transition: color 0.15s ease;\n}\n\n/* ── Force ALL svg children to inherit currentColor ─────────────────────── */\n/* Covers path, rect, circle, polyline, line regardless of stroke or fill   */\n.scl--cms-content-edit-product-breadcrumb-item svg {\n  width: 16px;\n  height: 16px;\n  flex-shrink: 0;\n  color: inherit;          /* cascade currentColor into the SVG element      */\n}\n\n.scl--cms-content-edit-product-breadcrumb-item svg *,\n.scl--cms-content-edit-product-breadcrumb-item svg path,\n.scl--cms-content-edit-product-breadcrumb-item svg rect,\n.scl--cms-content-edit-product-breadcrumb-item svg circle,\n.scl--cms-content-edit-product-breadcrumb-item svg line,\n.scl--cms-content-edit-product-breadcrumb-item svg polyline {\n  stroke: currentColor !important;\n  fill: none !important;      /* icons are outline style — no fill           */\n  transition: stroke 0.15s ease;\n}\n\n/* Exception: if an icon child explicitly needs fill (e.g. solid icon),\n   add class scl--fill to that SVG and override here */\n.scl--cms-content-edit-product-breadcrumb-item svg.scl--fill *,\n.scl--cms-content-edit-product-breadcrumb-item svg.scl--fill path {\n  fill: currentColor !important;\n  stroke: none !important;\n}\n\n/* ── Hover ───────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-product-breadcrumb-item:hover:not(:disabled) {\n  color: rgba(0, 0, 0, 0.8);\n}\n\n/* ── Focus-visible — keyboard / programmatic focus ──────────────────────── */\n.scl--cms-content-edit-product-breadcrumb-item:focus-visible:not(:disabled) {\n  color: #2388FF;\n  /* Subtle underline instead of a box — keeps layout stable */\n  text-decoration: underline;\n  text-underline-offset: 3px;\n}\n\n/* ── Active / current page ───────────────────────────────────────────────── */\n.scl--cms-content-edit-product-breadcrumb-item--active:not(:disabled)  {\n  color: #2388FF;\n  cursor: default;\n}\n\n/* ── Disabled ────────────────────────────────────────────────────────────── */\n.scl--cms-content-edit-product-breadcrumb-item:disabled {\n  cursor: default;\n  color: #8A8B8F;\n}\n\n/* ── Separator \"/\" ───────────────────────────────────────────────────────── */\n.scl--cms-content-edit-product-breadcrumb-sep {\n  font-family: 'Inter', sans-serif;\n  font-weight: 400;\n  font-size: 12px;\n  line-height: 18px;\n  color: #8A8B8F;\n  pointer-events: none;\n  user-select: none;\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
